



























































































































import store from '@/store'
import { dangerBar, successBar } from '@/lib/notif'

# origin data format
origin = -> {
  Phone: null
  Address1: null
  Address2: null
  City: null
  State: null
  Zipcode: null
}

export default {
  name: 'addressFormModal',
  props: {
    Id: { type: [String, Number], default: -> null }
  }
  data: -> {
    saving: no
    input: origin()
    # when load data to update
    updateLoading: no
    removeLoading: no
  }
  computed: {
    validateRule: -> {
      Address1: 'required'
      City: 'required'
      StateId: 'required'
      Zipcode: 'required'
      Phone: 'required'
    }
    # get real parent of code
    # parent lv1 is modal component , need back twice
    parent: -> this.$parent.$parent
    # check current stage is update and create
    isUpdateStage: -> this.Id? is yes
  }
  mounted: -> (
    self = this
    # trigger update
    setTimeout(
      -> if self.Id? then self.loadForUpdate()
      0
    )
  )
  methods: {

    # load data for update
    loadForUpdate: -> (
      # t = this
      
      # query = "query address($Id: Id!) {
      #   address(Id: $Id) {
      #   addressName FirstName LastName
      #   State City Zipcode
      #   Address1 Address2 Phone Email }
      # }"
      # request = store.dispatch 'centric2', { Id: t.Id }

      # t.updateLoading = yes
      # # with update case we need load detail of bank before start actions
      # address = (await request)?.address
      # t.updateLoading = no

      # if address?
      #   # can start
      #   t.input = Object.assign {}, t.input, address
      # else
      #   t.$parent.close()
      yes
    )

    onSubmit: -> this.$refs.form.onSubmit()

    formSubmit: -> (
      this.saving = yes
      response = await (
        if this.Id? then this.updateaddress()
        else this.make()
      )
      if response
        this.$emit 'done', response
        this.$parent.close()
      response
    )

    # create new
    make: -> (
      t = this
      # query = "mutation addressCreate($context: addressCreate!) {
      #   addressCreate(context: $context) {
      #     Id addressName FirstName LastName
      #     State City Zipcode
      #     Address1 Address2 Phone Email
      #   }
      # }"
      # variables = { context: t.input }
      # request = store.dispatch 'centric2', { query, variables }

      # t.saving = yes
      # newOnes = (await request)?.addressCreate
      # t.saving = no
      # if newOnes?
      #   successBar 'New address added.'
      #   [ newOnes, 'create' ]
      # else
      #   no
      successBar 'New address added.'
      newOnes = [{
        t.input...
        Id: Math.round (Math.random() * 1000)
      }]
      await [ newOnes, 'create' ]
    )

    # update bank
    updateaddress: -> (
      t = this
      # query = "mutation addressUpdate($context: addressUpdate! $Id: Id!) {
      #   addressUpdate(context: $context Id: $Id) {
      #     Id addressName FirstName LastName
      #     State City Zipcode
      #     Address1 Address2 Phone Email
      #   }
      # }"
      # variables = { context: t.input, Id: t.Id }
      # request = store.dispatch 'centric2', { query, variables }

      # t.saving = yes
      # updateOnes = (await request)?.addressUpdate
      # t.saving = no
      # if updateOnes?
      #   successBar "address account updated."
      #   [updateOnes, 'update']
      # else
      #   no
      updateOnes = [{
        t.input...
      }]
      await [updateOnes, 'update']
    )
  }
}
